import { render, staticRenderFns } from "./about.vue?vue&type=template&id=73675cb0"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextList: require('/usr/src/app/components/text/list.vue').default,TextTitleBlock: require('/usr/src/app/components/text/title-block.vue').default})
